export default __webpack_public_path__ + "static/cluster-mgmt-d0c0c8822a1a873e99f27e2b48aa5858.webp";